<template>
  <div class="menuFrame">
    <div class="container py-3">
      <div
        class="row flex-nowrap mx-2 pt-3 justify-content-between align-items-center"
      >
        <a href="https://www.chanchao.com.tw/">
          <div class="d-flex">
            <img
              src="../../assets/images/ChanChaoLogo.png"
              class="navLogo mt-2"
            />
            <div class="ml-2 mt-1 mt-md-0">
              <div class="navHead font-weight-nomal">展昭會員</div>
              <div class="text-muted navCnt">ChanChao Member</div>
            </div>
          </div>
        </a>

        <div>
          <select
            class="form-control language-select"
            v-model="selectedLang"
            @change="switchLanguage"
          >
            <option
              v-for="lang in languages"
              :key="lang.value"
              :value="lang.value"
            >
              {{ lang.label }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row formFrame m-1 py-2">
        <div class="lineRight col-md-7 my-4 px-4">
          <div class="d-flex align-items-center mb-4">
            <img
              src="../../assets/images/signupIcon.png"
              class="mr-2 mb-2"
              style="width: 40px; height: 40px"
              alt=""
            />
            <h4>會員註冊</h4>
          </div>

          <form>
            <div class="form-group h6">
              <label for="signupEmail"
                >電子郵件地址<span class="input-note">
                  *此為會員帳號不可修改</span
                >
              </label>
              <input
                type="email"
                name="email"
                class="form-control form-group"
                placeholder="請確實填寫可收信之信箱，系統將發出認證信給您"
                id="signupEmail"
                maxlength="50"
                aria-describedby="emailHelp"
                v-model="email"
                :class="{ 'is-invalid': errors.first('email') }"
                v-validate="'required|email'"
                ref="signupEmail"
              />
              <span
                class="text-danger"
                style="font-size: 10px"
                v-if="errors.first('email')"
                >{{ errors.first("email") }}
              </span>
            </div>
            <div class="form-group h6">
              <label for="signupPassword"
                >輸入認證碼<span class="input-note"> *</span></label
              >
              <div class="input-group mb-3">
                <input
                  type="text"
                  class="form-control"
                  placeholder="輸入六位數認證碼"
                  id="signupPassword"
                  maxlength="6"
                  v-model="verificationcode"
                  name="text"
                  :class="{ 'is-invalid': errors.first('text') }"
                  v-validate="'required'"
                  ref="signupPassword"
                />
                <div class="input-group-prepend">
                  <button
                    class="btn btn-secondary ml-3 py-0 px-3 rounded"
                    style="font-size: 16px"
                    @click.prevent="getverification"
                    type="button"
                  >
                    取得認證碼
                  </button>
                </div>
              </div>

              <div>
                <em style="font-size: 13px; color: grey"
                  >點擊【取得認證碼】按鈕，認證碼將寄至您的 email</em
                >
              </div>

              <span
                class="text-danger"
                style="font-size: 10px"
                v-if="errors.first('text')"
                >認證碼欄位不能留空
              </span>
            </div>
            <div class="form-group h6">
              <label for="signupName"
                >姓名<span class="input-note"> *</span></label
              >
              <input
                type="text"
                class="form-control"
                placeholder="請填寫真實姓名以利現場活動辨識"
                id="signupName"
                maxlength="30"
                v-model="name"
                name="name"
                :class="{ 'is-invalid': errors.first('name') }"
                v-validate="'required'"
                ref="signupName"
              />
              <span
                class="text-danger"
                style="font-size: 10px"
                v-if="errors.first('name')"
                >姓名欄位不能留空
              </span>
            </div>
            <div class="form-group h6">
              <label>手機<span class="input-note"> *</span></label>

              <vue-tel-input
                class="form-control"
                type="tel"
                v-bind="bindProps"
                placeholder=""
                v-model="allPhone"
                maxLen="20"
                name="interphone"
                :class="{ 'is-invalid': errors.first('interphone') }"
                v-validate="'required'"
              ></vue-tel-input>
              <span
                class="text-danger"
                style="font-size: 10px"
                v-if="errors.first('interphone')"
                >手機欄位不能留空
              </span>
            </div>

            <div class="form-group h6">
              <label for="signupPassword1"
                >密碼<span class="input-note"> *</span></label
              >
              <div class="input-group mb-3">
                <input
                  type="password"
                  :type="typePwd"
                  name="password"
                  class="form-control"
                  placeholder="密碼長度 8-20 字元"
                  id="signupPassword1"
                  autocomplete="off"
                  maxlength="20"
                  v-model="password"
                  :class="{ 'is-invalid': errors.first('password') }"
                  v-validate="'required'"
                  ref="password"
                  data-vv-as="密碼欄位"
                />
                <div class="input-group-append">
                  <span
                    class="input-group-text"
                    id="basic-addon2"
                    @click.prevent="showPw"
                  >
                    <i class="fas fa-eye" v-if="typePwd == 'password'"></i>
                    <i
                      class="fas fa-eye-slash"
                      v-else-if="typePwd == 'text'"
                    ></i>
                  </span>
                </div>
              </div>
              <span
                class="text-danger"
                style="font-size: 10px"
                v-if="errors.first('password')"
                >{{ errors.first("password") }}
              </span>
            </div>

            <div class="form-group h6">
              <label for="signupPassword2"
                >密碼確認<span class="input-note"> *</span></label
              >
              <div class="input-group mb-3">
                <input
                  type="password"
                  :type="typePwd"
                  class="form-control"
                  placeholder="請再次輸入密碼"
                  id="signupPassword2"
                  autocomplete="off"
                  maxlength="20"
                  v-model="confirmpassword"
                  name="password_confirmation"
                  :class="{
                    'is-invalid': errors.first('password_confirmation'),
                  }"
                  v-validate="'required|confirmed:password'"
                  data-vv-as="密碼確認欄位"
                  ref="signupPassword2"
                />
                <div class="input-group-append">
                  <span
                    class="input-group-text"
                    id="basic-addon2"
                    @click.prevent="showPw"
                  >
                    <i class="fas fa-eye" v-if="typePwd == 'password'"></i>
                    <i
                      class="fas fa-eye-slash"
                      v-else-if="typePwd == 'text'"
                    ></i>
                  </span>
                </div>
              </div>
              <span
                class="text-danger"
                style="font-size: 10px"
                v-if="errors.first('password_confirmation')"
              >
                {{ errors.first("password_confirmation") }}
              </span>
            </div>

            <div class="form-check ml-1">
              <input
                class="form-check-input"
                type="checkbox"
                value=""
                id="signupCheck"
                v-model="checkedrule"
                maxlength="20"
              />
              <label
                class="form-check-label"
                for="signupCheck"
                style="font-size: 15px"
              >
                <span>我已閱讀、了解並同意接受【</span>
                <a href="//www.chanchao.com.tw/otherMember.asp" target="_blank"
                  >服務條款</a
                ><span>】之內容</span>
                <span v-if="checkText" class="text-danger ml-1"
                  >**請勾選**</span
                >
              </label>
            </div>

            <button
              type="submit"
              class="btn btn-block btn-primary mt-4"
              @click.prevent="signupBtn"
            >
              註冊
            </button>
          </form>

          <hr />
          <div class="linkFrame">
            <span>已經加入展昭展覽網? </span>
            <span>
              <router-link to="/login">會員登入</router-link>
            </span>
          </div>
        </div>

        <div class="col-md-5 my-4 px-4 lineBottom">
          <div class="d-flex align-items-center mb-4">
            <img
              src="../../assets/images/user.svg"
              class="mr-3"
              style="width: 50px; height: 50px"
              alt=""
            />
            <div>
              <h4>免費註冊會員</h4>
              <h6>看展更快速，產業訊息更流通</h6>
            </div>
          </div>
          <p>
            快速獲得展覽最新消息、活動索票資訊、專屬展昭會員優惠及權利，並可免費訂閱會員電子報及展覽資訊報。
          </p>

          <hr />

          <h4 class="my-4">常見問題</h4>
          <ul class="ml-0 pl-4">
            <li>
              <a
                href="//www.chanchao.com.tw/downloads/%E6%9C%83%E5%93%A1%E8%A8%BB%E5%86%8A%E7%AF%87.pdf"
                target="_blank"
                >如何加入會員?</a
              >
            </li>
            <li>
              <a
                href="//www.chanchao.com.tw/downloads/04%E9%82%80%E8%AB%8B%E4%BB%A3%E7%A2%BC%E7%B4%A2%E7%A5%A8.pdf"
                target="_blank"
                >如何索票? 何謂邀請代碼入場?</a
              >
            </li>
            <li>
              <a
                href="//www.chanchao.com.tw/downloads/03%E5%BF%AB%E9%80%9F%E5%85%A5%E5%A0%B4%E7%AF%87(%E6%89%8B%E6%A9%9F%E7%89%88).pdf"
                target="_blank"
                >如何快速掃描入場?</a
              >
            </li>
          </ul>

          <div class="d-flex mt-3">
            <a href="//www.chanchao.com.tw/qa.asp" target="_blank"
              >更多常見問題<i class="fas fa-external-link-alt ml-2"></i
            ></a>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/footer.vue";

export default {
  // metaInfo: {
  //   title: '會員註冊 - 展昭展覽網',
  // },
  components: {
    Footer,
  },

  data() {
    return {
      mobile: "",
      mobilecountrycode: "",
      name: "",
      email: "",
      verificationcode: "",
      confirmpassword: "",
      password: "",
      allPhone: "",
      bindProps: {
        mode: "international",
        defaultCountry: "TW",
      },
      checkedrule: false,
      typePwd: "password",
      alertTitle: "",
      alertText: "",
      lastUrl: "",
      checkText: false,
      CSRF_Token: "",
      selectedLang: "tw",
      languages: [
        { label: "中文", value: "tw" },
        { label: "English", value: "en" },
        { label: "Tiếng Việt", value: "vn" },
        { label: "ភាសាខ្មែរ", value: "km" },
        { label: "ภาษาไทย", value: "th" },
        { label: "বাংলা ভাষা", value: "bd" },
      ],
    };
  },

  watch: {
    email: function () {
      const vm = this;
      vm.$refs.signupEmail.style.borderColor = "#ced4da";
    },

    verificationcode: function () {
      const vm = this;
      vm.$refs.signupPassword.style.borderColor = "#ced4da";
    },

    name: function () {
      const vm = this;
      vm.$refs.signupName.style.borderColor = "#ced4da";
    },

    password: function () {
      const vm = this;
      vm.$refs.password.style.borderColor = "#ced4da";
    },

    confirmpassword: function () {
      const vm = this;
      vm.$refs.signupPassword2.style.borderColor = "#ced4da";
    },
  },

  methods: {
    switchLanguage() {
      const langCode = this.selectedLang;

      if (langCode === "tw") {
        window.location.href = `https://www.chanchao.com.tw/accounts/signup`;
      } else {
        window.location.href = `https://www.chanchao.com.tw/accounts/${langCode}/signup`;
      }
    },
    signupBtn() {
      const vm = this;

      // Divide Phone Number

      let countryCode = vm.allPhone
        .substr(1)
        .substring(0, vm.allPhone.indexOf(" ") - 1);
      let phoneNum = vm.allPhone
        .substring(vm.allPhone.indexOf(" "), vm.allPhone.length)
        .replace(/\s*/g, "");

      const signupinfo = {
        Email: vm.email,
        VerificationCode: vm.verificationcode,
        MemberName: vm.name,
        Mobile: phoneNum,
        MobileCountryCode: countryCode,
        spass: vm.password,
        CSRF: vm.CSRF_Token,
      };

      const url = "https://www.chanchao.com.tw/apiLogin2/signup";

      vm.$validator.validate().then((valid) => {
        if (valid) {
          if (vm.password.length > 7) {
            if (vm.checkedrule) {
              vm.$http.post(url, signupinfo).then(function (response) {
                // // console.log(response)
                if (response.data == "200") {
                  vm.alertTitle = "註冊成功";
                  vm.alertText =
                    "感謝您的加入，請立即登入開始享受更多專屬服務。";
                  vm.alertSuccessSignup();
                } else if (response.data == "252") {
                  vm.alertText = "您已重複註冊！";
                  vm.alertError();
                  vm.$refs.signupEmail.style.borderColor = "red";
                } else if (response.data == "253") {
                  vm.alertText = "您的認證碼錯誤！";
                  vm.alertError();
                  vm.$refs.signupPassword.style.borderColor = "red";
                } else if (response.data == "254") {
                  window.location.replace("https://www.chanchao.com.tw/");
                } else {
                  vm.alertText = "系統忙碌，請稍後登入！";
                  vm.alertError();
                }
              });
            } else {
              vm.alertText = "您未勾選同意服務條款！";
              vm.alertError();
              vm.checkText = true;
            }
          } else {
            vm.alertText = "密碼請輸入 8-20 字元！";
            vm.alertError();
            vm.$refs.password.style.borderColor = "red";
            vm.$refs.signupPassword2.style.borderColor = "red";
          }
        } else {
          vm.alertText = "輸入欄位不完整，請重新檢查！";
          vm.alertError();
        }
      });
    },

    getverification() {
      const vm = this;

      vm.$validator.validate("email").then((valid) => {
        if (valid) {
          const url = "https://www.chanchao.com.tw/apiLogin2/verification/tw";

          const verificationemail = {
            Email: vm.email,
            CSRF: vm.CSRF_Token,
          };

          vm.$http.post(url, verificationemail).then(function (response) {
            // console.log(response)
            if (response.data == "200") {
              vm.alertText = `認證碼已寄至您填寫的信箱！${vm.email}`;

              vm.alertSuccess();
            } else if (response.data == "252") {
              vm.alertText = "輸入的郵件地址已經註冊過！";
              vm.alertError();
              vm.$refs.signupEmail.style.borderColor = "red";
            } else if (response.data == "253") {
              vm.alertText = "請輸入正確的Email";
              vm.alertError();
              vm.$refs.signupEmail.style.borderColor = "red";
            } else if (response.data == "254") {
              window.location.replace("https://www.chanchao.com.tw/");
            } else if (response.data == "255") {
              vm.alertText =
                "抱歉，您填寫的電子郵件@後方的網域錯誤，請修正後再按下取得認證碼，謝謝。";
              vm.alertError();
              vm.$refs.signupEmail.style.borderColor = "red";
            } else if (response.data == "256") {
              vm.alertText =
                "抱歉，您填寫的電子郵件為臨時電子郵件，無法取得認證。請使用其他電子郵件進行註冊，謝謝。";
              vm.alertError();
              vm.$refs.signupEmail.style.borderColor = "red";
            } else {
              vm.alertText = "系統忙碌，請稍後登入！";
              vm.alertError();
            }
          });
        } else {
          // 如果 email 驗證失敗，顯示錯誤訊息
          vm.alertText = "請輸入有效的電子郵件地址";
          vm.alertError();
          vm.$refs.signupEmail.style.borderColor = "red";
        }
      });
    },

    showPw() {
      const vm = this;
      vm.typePwd = vm.typePwd === "password" ? "text" : "password";
    },
    alertError() {
      const vm = this;
      vm.$swal({
        // title: vm.alertTitle,
        text: vm.alertText,
        icon: "info",
        confirmButtonText: "OK",
        // animation: false,
        allowOutsideClick: true,
        confirmButtonColor: "#abc6d2",
        width: 300,
        padding: 15,
      });
    },

    alertSuccess() {
      const vm = this;
      vm.$swal({
        title: vm.alertTitle,
        text: vm.alertText,
        icon: "success",
        confirmButtonText: "OK",
        // animation: false,
        allowOutsideClick: true,
        confirmButtonColor: "#abc6d2",
        width: 300,
        padding: 15,
      });
    },

    alertSuccessSignup() {
      const vm = this;
      vm.$swal({
        title: vm.alertTitle,
        text: vm.alertText,
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonColor: "#abc6d2",
        width: 300,
        padding: 15,
      }).then(function () {
        if (vm.lastUrl.length > 0) {
          window.location.replace(vm.lastUrl);
        } else {
          window.location.replace("https://www.chanchao.com.tw/member"); //注意能否直接到會員中心頁
        }
      });
    },
  },

  created() {
    const vm = this;

    vm.$http
      .get("https://www.chanchao.com.tw/apiLogin2/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    //取得上頁網址(from cookie)
    if (vm.$cookies.get("url")) {
      vm.lastUrl = vm.$cookies.get("url");

      // console.log(vm.lastUrl)
    } else {
      vm.lastUrl = "https://www.chanchao.com.tw/member";
    }

    //取得網址內信箱及認證碼

    let getUrlString = location.href;
    let getParams = new URL(getUrlString);

    let memberid = getParams.searchParams.get("e");
    let vCode = getParams.searchParams.get("v");

    vm.email = memberid;
    vm.verificationcode = vCode;

    //更換英文語系
    vm.$i18n.locale = "zhTW";
  },
};
</script>

<style lang="scss" scoped>
//Swal setting

.swal2-popup {
  font-size: 13px !important;
}

.swal2-styled.swal2-confirm {
  font-size: 10px;
}
.menuFrame {
  background-color: #f2f2f2;
  min-height: 100%;
}

.formFrame {
  background-color: #ffffff;
  margin-top: 40px;
  border-radius: 10px;
  box-shadow: 1px 1px 1px 1px rgba(201, 199, 199, 0.5);
}

.lineRight {
  border-right: 1px solid #ccc;
}

.navEnText:hover {
  color: rgb(34, 34, 34) !important;
}

.navLogo {
  height: 55px;
}

.navHead {
  font-size: 29px;
  color: #2c3e50;
}

.navCnt {
  font-size: 17px;
}

@media (max-width: 768px) {
  .lineRight {
    border-right: 0px;
  }

  .lineBottom {
    border-top: 0.5px solid rgb(230, 227, 227);
    padding-top: 30px;
  }

  .navEnText {
    display: none;
  }

  .navHead {
    font-size: 23px;
    color: #2c3e50;
  }

  .navCnt {
    font-size: 14px;
  }

  .navLogo {
    height: 50px;
  }
}

@media (max-width: 992px) {
  .auth-code {
    margin-top: 20px;
    margin-bottom: 20px;
  }
}

.input-note {
  font-size: 14px;
  color: rgb(190, 67, 67);
}

input::-webkit-input-placeholder {
  /* placeholder*/
  color: #aab2bd;
  font-size: 14px;
}

.linkFrame {
  font-size: 15px;
}

.linkText {
  position: relative;
}

.linkLine {
  position: absolute;
  height: 13px;
  //width: 33px;
  top: 20%;
  left: 0;
  border-left: 2px solid #a1a7a8;
}
</style>
